<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'work'
    }
</script>

<style lang="scss" scoped>

</style>